import { Tooltip, Typography } from "@mui/joy";
import { Box } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
// import PropTypes from 'prop-types';
// image
import type { KeyboardEvent, MouseEvent } from "react";
import { useDispatch } from "react-redux";
import { setSelectedTalentID } from "../../../redux/filmsReducer";
import { useTalent } from "../../../redux/talent/talentHooks";
import { Talent } from "../../../entities/talent";

export default function TalentAvatar({
  talentID = undefined,
  border = 0,
  talent: _talent = {},
  noTooltip = false,
  noRedirect = false,
  size = 40,
  active = false,
}: {
  talentID?: number;
  border?: number;
  talent?: any;
  noTooltip?: boolean;
  noRedirect?: boolean;
  size?: number;
  active?: boolean;
}) {
  let { talent } = useTalent(talentID);
  if (!talentID) talent = new Talent(_talent);

  const dispatch = useDispatch();
  const canRedirect = !noRedirect;

  const handleActivate = (event: MouseEvent | KeyboardEvent) => {
    event.stopPropagation();
    event.preventDefault();
    if (canRedirect) dispatch(setSelectedTalentID(talent?.id));
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (!canRedirect) return;
    if (event.key === "Enter" || event.key === " ") {
      handleActivate(event);
    }
  };

  return (
    <div
      className="talentAvatarInteractive"
      style={{ display: "inline-block" }}
      role={canRedirect ? "button" : undefined}
      tabIndex={canRedirect ? 0 : -1}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
      aria-label={
        canRedirect
          ? `Open ${talent?.fullName?.() ?? "talent"} profile`
          : undefined
      }
    >
      <Tooltip
        size="sm"
        enterDelay={1000}
        enterNextDelay={1000}
        arrow
        title={
          !noTooltip ? (
            <Typography
              level="body4"
              sx={{ textAlign: "center", color: "inherit" }}
            >
              <b>{talent?.fullName()}</b>
              <br />
              <Typography
                level="body5"
                sx={{ textAlign: "center", color: "inherit" }}
              >
                Click to open profile <i className="fa-solid fa-arrow-up"></i>
              </Typography>
            </Typography>
          ) : undefined
        }
        style={{ cursor: !noTooltip && canRedirect ? "pointer" : undefined }}
      >
        <Badge
          overlap="circular"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          badgeContent={
            !talent?.active ? (
              <Avatar
                sx={{
                  background: "#B29F85",
                  width: 14,
                  fontSize: 7,
                  height: 14,
                  textAlign: "center",
                  border: "solid 1px white",
                }}
              >
                <i className="fa-solid fa-box-archive"></i>
              </Avatar>
            ) : (
              []
            )
          }
        >
          <Box
            sx={{
              background: "transparent",
              borderRadius: "100%",
              padding: "1px",
              position: "relative",
            }}
          >
            <Avatar
              style={{
                fontSize: size / 2.2,
                fontWeight: 800,
                height: size,
                width: size,
                background: active
                  ? "rgba(33,150,243,0.3)"
                  : "rgba(155,155,155,0.3)",
                border: `solid ${border}px white`,
                boxShadow: border
                  ? "0px 2px 2px rgba(155,155,155,0.3)"
                  : undefined,
                color: "#757575",
              }}
            >
              {talent?.code ?? talent?.initials()}
            </Avatar>
          </Box>
        </Badge>
      </Tooltip>
    </div>
  );
}
